import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import i18n from './lang'
import imageMixin from './mixins/imageMixin'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)


// 根据语言获取图片路径的辅助函数
function getLangImagePath(imageName) {
    const lang = localStorage.getItem('lang') || 'zh';
    const folder = lang === 'en' ? 'img-en' : 'img-zh';
    return require(`./assets/${folder}/${imageName}`);
}

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
    error: getLangImagePath('error.png'),
    //加载时显示的GIF图
    loading: getLangImagePath('loading.gif'),
  //尝试加载几次
  attempt: 1,
  delay: 10000
});

Vue.config.productionTip = false

// 注册全局混入
Vue.mixin(imageMixin)

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
require('../static/requestConfig')
// axios.defaults.baseURL = 'http://www.v6_2.com/company/api/'
axios.defaults.baseURL = window.g.baseUrl
// 添加请求拦截器，自动携带语言参数
axios.interceptors.request.use(
    config => {
      const lang = i18n.locale || localStorage.getItem('lang') || 'zh'

      // 如果 URL 中还没有 lang 参数，则添加
      if (config.url && !config.url.includes('lang=')) {
        const separator = config.url.includes('?') ? '&' : '?'
        config.url += `${separator}lang=${lang}`
      }

      return config
    },
    error => {
      return Promise.reject(error)
    }
)
Vue.prototype.$http = axios

// 图片服务器地址
// Vue.prototype.imgserver = 'http://www.v6_2.com/'
Vue.prototype.imgserver = window.g.imgserver

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

